import React from "react"
import AnchorIcon from "@mui/icons-material/Anchor"
import PilotStationIcon from "@mui/icons-material/LocalParkingRounded"
import ErrorIcon from "@mui/icons-material/Error"
import InfoIcon from "@mui/icons-material/Info"
import DoNotDisturbOnIcon from "@mui/icons-material/DoNotDisturbOn"
import DoNotDisturbOffIcon from "@mui/icons-material/DoNotDisturbOff"

// One marker look per point layer, shared by map markers, cluster badges and the GIS panel legend.
export const GIS_MARKERS = {
  port: { Icon: AnchorIcon, color: "#37474f", rgb: [55, 71, 79] },
  pilot: { Icon: PilotStationIcon, color: "#800080", rgb: [128, 0, 128] },
  restriction: { Icon: ErrorIcon, color: "#ffa500", rgb: [255, 165, 0] },
  region: { Icon: InfoIcon, color: "#0000ff", rgb: [0, 0, 255] },
  viaClosed: { Icon: DoNotDisturbOnIcon, color: "#ff0000", rgb: [255, 0, 0] },
  viaOpen: { Icon: DoNotDisturbOffIcon, color: "#008000", rgb: [0, 128, 0] },
}

export function GisMarkerSwatch({ marker }) {
  const { Icon, color } = GIS_MARKERS[marker]
  return (
    <div
      style={{
        width: "18px",
        height: "18px",
        borderRadius: "50%",
        background: "white",
        border: `2px solid ${color}`,
        boxSizing: "border-box",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Icon style={{ color, fontSize: 14 }} />
    </div>
  )
}
